const StatusBadge = ({ status }) => {
  const styles = {
    pending: 'bg-amber-100 text-amber-700',
    resolved: 'bg-green-100 text-green-700',
    'in-progress': 'bg-blue-100 text-blue-700'
  };

  return (
    <span
      className={`px-2 py-0.5 rounded text-[9px] font-bold uppercase ${
        styles[status] || 'bg-gray-100 text-gray-700'
      }`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
